import { DwMdEventHandler, DwMetaDataEventEntity, DwMdEventHandlerService, DwMdEventData } from '@devwareapps/devware-cap';
import { Injectable } from '@angular/core';



@DwMdEventHandler({
key:'EventServiceTest',
name:'Event Service Test (Prototypes)',
useDi:true,
})
@Injectable({
providedIn:'root'
})
export class EventServiceTest implements DwMdEventHandlerService {
handleEvent(event: DwMetaDataEventEntity, eventData: DwMdEventData): void {


  console.log(`EventServiceTest (Prototype) Event:  ${eventData.eventType} for ${eventData.itemName}`, eventData);
    }
}

